export default {
  "show_more_statistics_title": "Show More Statistics",
  "show_more_statistics_tips": "The statistical values will be displayed at the end of the table.",
}
